// Shared bits of the Localization page: the tiers, the job views, small helpers.
export const TIERS = [
    { value: 0, label: "none", short: "—", color: "#eeeeee" },
    { value: 1, label: "AI isolated", short: "AI·i", color: "#ffe0b2" },
    { value: 2, label: "AI context", short: "AI·c", color: "#fff59d" },
    { value: 3, label: "human generic", short: "H·g", color: "#bbdefb" },
    { value: 4, label: "human revised", short: "H·r", color: "#90caf9" },
    { value: 5, label: "human specialized", short: "H·s", color: "#c8e6c9" },
];
export const TIER_NAMES = ["None", "AiIsolated", "AiContext", "HumanGeneric", "HumanRevised", "HumanSpecialized"];
export const tierOf = (v) => TIERS[Math.max(0, Math.min(5, v ?? 0))];

// Owner's rule: a table never sizes its own columns. Pass this to every DataTable/PagedTable and give EVERY column
// an explicit width (percentages that add to 100, or a pixel width for a narrow fixed cell).
export const FIXED_TABLE = { "& table": { tableLayout: "fixed" } };

export const usd4 = (v) => `$${(v ?? 0).toFixed(v >= 1 ? 2 : 3)}`;

export const isActive = (job) => job && (job.status === "queued" || job.status === "running");

// The folders of the tree as nested nodes (children in tree order) plus a lookup by path
export function buildFolderTree(folders) {
    const byPath = new Map();
    const roots = [];
    const sorted = [...(folders ?? [])].sort((a, b) => a.order - b.order);
    sorted.forEach(f => byPath.set(f.path, { ...f, children: [] }));
    sorted.forEach(f => {
        const node = byPath.get(f.path);
        const i = f.path.lastIndexOf("/");
        const parent = i < 0 ? null : byPath.get(f.path.slice(0, i));
        if (parent) parent.children.push(node); else roots.push(node);
    });
    return { roots, byPath };
}

// Tags of a folder and its subfolders, from the tree's counts
export function countBelow(node) {
    return (node.tags ?? 0) + node.children.reduce((n, c) => n + countBelow(c), 0);
}
